import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Sparkles } from 'lucide-react';
export function PricingSection() {
  const handleCheckoutClick = () => {
    // Track InitiateCheckout event with Facebook Pixel
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
    // Redirect to checkout page with UTM parameters
    const checkoutUrl = 'https://pay.cakto.com.br/39bytf3_682112';
    const urlParams = window.location.search;
    window.location.href = checkoutUrl + urlParams;
  };
  return <section id="pricing" className="py-16 md:py-24 bg-gradient-to-br from-amber-50 via-white to-yellow-50 relative overflow-hidden" data-id="element-205">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-5" data-id="element-206">
        <div className="absolute top-20 left-10 w-64 h-64 bg-amber-400 rounded-full blur-3xl" data-id="element-207"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-yellow-400 rounded-full blur-3xl" data-id="element-208"></div>
      </div>

      <div className="max-w-3xl mx-auto px-4 md:px-6 relative z-10" data-id="element-209">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-210">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-100 to-yellow-100 px-5 py-1.5 rounded-full mb-4 border border-amber-200" data-id="element-211">
            <Sparkles className="w-4 h-4 text-amber-600" data-id="element-212" />
            <span className="text-xs font-semibold uppercase tracking-wider text-amber-700" data-id="element-213">
              Oferta Especial
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-stone-900 mb-3" data-id="element-214">
            A Fórmula do Efeito Boutique™
          </h2>
          <p className="text-base md:text-lg text-stone-600 max-w-2xl mx-auto" data-id="element-215">
            Transforme suas lembrancinhas com o método profissional
          </p>
        </motion.div>

        {/* Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white rounded-3xl shadow-2xl border-2 border-amber-200 overflow-hidden" data-id="element-216">
          {/* Price Section */}
          <div className="bg-gradient-to-br from-amber-500 to-yellow-600 p-6 md:p-8 text-center text-white" data-id="element-217">
            <p className="text-base md:text-lg font-medium mb-1 opacity-90" data-id="element-218">
              De <span className="line-through" data-id="element-219">R$ 97,00</span> por
            </p>
            <p className="text-4xl md:text-5xl lg:text-6xl font-bold mb-3" data-id="element-220">
              R$ 29,90
            </p>
            <p className="text-sm md:text-base opacity-90" data-id="element-221">
              Investimento único • Acesso vitalício
            </p>
          </div>

          {/* Content Section */}
          <div className="p-6 md:p-8" data-id="element-222">
            <h3 className="text-lg md:text-xl font-bold text-stone-900 mb-5 text-center" data-id="element-223">
              O que você vai receber:
            </h3>

            <ul className="space-y-3 mb-6" data-id="element-224">
              <li className="flex items-start gap-3" data-id="element-225">
                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center mt-0.5" data-id="element-226">
                  <Check className="w-3.5 h-3.5 text-green-600" data-id="element-227" />
                </div>
                <span className="text-sm md:text-base text-stone-700" data-id="element-228">
                  <strong data-id="element-229">40 ideias completas</strong> testadas e aprovadas
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-230">
                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center mt-0.5" data-id="element-231">
                  <Check className="w-3.5 h-3.5 text-green-600" data-id="element-232" />
                </div>
                <span className="text-sm md:text-base text-stone-700" data-id="element-233">
                  <strong data-id="element-234">Passo a passo detalhado</strong> com fotos e
                  instruções
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-235">
                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center mt-0.5" data-id="element-236">
                  <Check className="w-3.5 h-3.5 text-green-600" data-id="element-237" />
                </div>
                <span className="text-sm md:text-base text-stone-700" data-id="element-238">
                  <strong data-id="element-239">Templates prontos</strong> para usar imediatamente
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-240">
                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center mt-0.5" data-id="element-241">
                  <Check className="w-3.5 h-3.5 text-green-600" data-id="element-242" />
                </div>
                <span className="text-sm md:text-base text-stone-700" data-id="element-243">
                  <strong data-id="element-244">Calculadora de custos</strong> para planejar seu
                  orçamento
                </span>
              </li>
            </ul>

            {/* Bonus Section */}
            <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-2xl p-5 mb-6 border-2 border-amber-200" data-id="element-245">
              <div className="flex items-center gap-2 mb-3" data-id="element-246">
                <Gift className="w-4 h-4 text-amber-600" data-id="element-247" />
                <h4 className="text-base md:text-lg font-bold text-stone-900" data-id="element-248">
                  Bônus Exclusivos
                </h4>
              </div>
              <ul className="space-y-2.5" data-id="element-249">
                <li className="flex items-start gap-3" data-id="element-250">
                  <div className="flex-shrink-0 w-5 h-5 rounded-full bg-amber-200 flex items-center justify-center mt-0.5" data-id="element-251">
                    <Gift className="w-3.5 h-3.5 text-amber-700" data-id="element-252" />
                  </div>
                  <span className="text-sm md:text-base text-stone-700 font-medium" data-id="element-253">
                    Lista completa de materiais e custos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-254">
                  <div className="flex-shrink-0 w-5 h-5 rounded-full bg-amber-200 flex items-center justify-center mt-0.5" data-id="element-255">
                    <Gift className="w-3.5 h-3.5 text-amber-700" data-id="element-256" />
                  </div>
                  <span className="text-sm md:text-base text-stone-700 font-medium" data-id="element-257">
                    Truques secretos do Efeito Boutique™
                  </span>
                </li>
              </ul>
            </div>

            {/* CTA Button */}
            <motion.button onClick={handleCheckoutClick} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-gradient-to-r from-amber-500 to-yellow-600 hover:from-amber-600 hover:to-yellow-700 text-white font-bold text-base md:text-lg px-8 py-4 rounded-full shadow-xl transition-all duration-300 mb-4" data-id="element-258">
              Quero Acesso Agora
            </motion.button>

            <div className="text-center space-y-1.5" data-id="element-259">
              <p className="text-xs md:text-sm text-stone-600 flex items-center justify-center gap-2" data-id="element-260">
                <Check className="w-3.5 h-3.5 text-green-600" data-id="element-261" />
                Acesso imediato após o pagamento
              </p>
              <p className="text-xs md:text-sm text-stone-600 flex items-center justify-center gap-2" data-id="element-262">
                <Check className="w-3.5 h-3.5 text-green-600" data-id="element-263" />
                Pagamento 100% seguro
              </p>
              <p className="text-xs md:text-sm text-stone-600 flex items-center justify-center gap-2" data-id="element-264">
                <Check className="w-3.5 h-3.5 text-green-600" data-id="element-265" />
                Garantia de 7 dias
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}